import { render, staticRenderFns } from "./SubStatus.vue?vue&type=template&id=3e150232&scoped=true"
import script from "./SubStatus.vue?vue&type=script&lang=js"
export * from "./SubStatus.vue?vue&type=script&lang=js"
import style0 from "./SubStatus.vue?vue&type=style&index=0&id=3e150232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e150232",
  null
  
)

export default component.exports